import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../lib/apiClient';
import type { EmailSubscriptionSettings } from '../types';

/**
 * Query hook for fetching user email subscription settings
 *
 * Fetches email preferences from the User API.
 *
 * @param userAuthUuid - User's auth service UUID
 * @returns TanStack Query result with email subscription settings
 */
export const useEmailSubscriptionQuery = (userAuthUuid: string | undefined) => {
  return useQuery({
    queryKey: ['emailSubscription', userAuthUuid],
    queryFn: async () => {
      return await apiClient().get(`api/users/${userAuthUuid}/settings/email`).json<EmailSubscriptionSettings>();
    },
    enabled: !!userAuthUuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
